import { Typography } from '@material-ui/core'
import React from 'react'
import Popup from '../Popup'

export default ({ open, messagePost = '', onConfirm = () => {} }) => {
  return (
    <Popup
      position='top'
      open={open}
      variant='warning'
      message={
        <Typography>
          We use cookies to ensure you get the best experience on our app.{' '}
          {messagePost}
        </Typography>
      }
      onClick={onConfirm}
      preventCancel={false}
    />
  )
}
